import { render, staticRenderFns } from "./OverviewOtherPurchases.vue?vue&type=template&id=202774a8&scoped=true"
import script from "./OverviewOtherPurchases.vue?vue&type=script&lang=js"
export * from "./OverviewOtherPurchases.vue?vue&type=script&lang=js"
import style0 from "./OverviewOtherPurchases.vue?vue&type=style&index=0&id=202774a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202774a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('202774a8')) {
      api.createRecord('202774a8', component.options)
    } else {
      api.reload('202774a8', component.options)
    }
    module.hot.accept("./OverviewOtherPurchases.vue?vue&type=template&id=202774a8&scoped=true", function () {
      api.rerender('202774a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/components/OverviewOtherPurchases.vue"
export default component.exports